<template>
    <div>
        <div class="actFormWrap" style="flex-flow: column nowrap">
            <div class="dfrnsa w100" v-for="(item, index) in inputData">
                <a-form-item :label="labelName" class="dfrn requiredForm w85">
                    <a-input class="w300p" v-model="item.value" :placeholder="'请输入名称'" @keyup.enter="handleOkhandleOk"/>
                </a-form-item>
                <div v-show="!isEdit" class="dfrn w10">
                    <a-icon @click="setUp(index)" class="f22 mab20 cp cccc hoverc666" type="up-circle" />
                    <a-icon @click="setDown(index)" class="f22 mab20 cp cccc hoverc666" type="down-circle" />
                </div>
            </div>
            <div v-show="!isEdit" class="actWrap" style="min-height: auto;">
                <div class="actAdd" @click="addNewInput" style="width: 440px;height: 50px;line-height: 50px;text-align: center;">
                    <a-icon type="plus" />
                    {{ addNewText || '添加' }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        labelName: {
            type:String,
            required: false
        },
        placeholder: {
            type:String,
            required: false
        },
        addNewText: {
            type:String,
            required: false
        },
        isEdit: {
            type:Boolean,
            required: false
        }
    },
    data() {
        return {
            inputData:[
                {
                    value: '',
                }
            ]
        }
    },
    mounted (){
        console.log(this.labelName);
        console.log(this.placeholder);
        this.initData();
    },
    methods: {
        handleOkhandleOk(){
            this.$emit('handleOk');
        },
        initData(){
            if (this.placeholder !== '章名称' && this.placeholder != '小节名称'){
                this.inputData = [{value: this.placeholder}];
            }else {
                this.inputData = [{value: ''}];
            }
        },
        addNewInput(){
            this.inputData.push({value: ''});
        },
        setUp(index){
            if (index <= 0){
                // that.$message.success('删除成功');
                this.$message.error('不能移动');
                return false;
            }
            let newData = this.inputData[index].value;
            this.inputData[index].value = this.inputData[index-1].value;
            this.inputData[index-1].value = newData;
        },
        setDown(index){
            if (index >= this.inputData.length-1){
                // that.$message.success('删除成功');
                this.$message.error('不能移动');
                return false;
            }
            let newData = this.inputData[index].value;
            this.inputData[index].value = this.inputData[index+1].value;
            this.inputData[index+1].value = newData;
        }
    },
};
</script>
<style lang="less"> 
</style>